import React from 'react'
import { Modal, Button, Tabs,Image, Row } from 'antd'
import {prUrl} from '../config.js'

const { TabPane } = Tabs;

const EventDetails = (props) => {
    const { event, isModalOpen, handleModalShow } = props
    return (
        <Modal title="热点事件" maskClosable={false} width={'70vw'} visible={isModalOpen} onCancel={handleModalShow}
            footer={[<Button key="close" type="primary" onClick={handleModalShow}>关闭</Button>]}>
            <Tabs key={event} defaultActiveKey={"1"}>
                <TabPane tab="事件详情" key="1" style={{align:'center'}}>
                    <p>时间：{event.time}</p>
                    <Row align='middle' justify='center'>
                        {event.image !== "" && <Image visible={event.image}  src={prUrl + event.image} style={{width:500}}/>}
                    </Row>
                    <p>{event.text}</p>
                </TabPane>                    
            </Tabs>  
        </Modal>
    )
}

export default EventDetails